import { ParsedCsvRow, TableRow, OrderBy, OrderColumn, OrderDirection } from "./types";
import { DetectionFilterInput } from "../../../redux/detections/detection-types";
import { Animal } from "../../../redux/animals/animals-types";
import { callGqlApi } from "../../../helpers/api";
import gql from "../../../redux/gqlTag";
import { SortModelItem } from "ag-grid-community";

export const sensorUnits = {
  TEMPERATURE: "°C",
  DEPTH: "m",
  ACCELERATION: "m/s²",
};

export function csvRowToTableRow(
  r: ParsedCsvRow,
  allAnimals: Animal[],
  fileIdToNameMap: Map<string, string>
): TableRow {
  const animal_ids = r.animal_ids?.split(";") || [];
  const animal_conflict = animal_ids && animal_ids.length > 1;
  const animals: Animal[] = allAnimals.filter(a => animal_ids.includes(a.id)) || [];

  const file_ids = r.files.split(";");
  const file_names: string[] = file_ids
    .map(id => fileIdToNameMap.get(id))
    .filter((name): name is string => typeof name === "string" && name.length > 0);

  let sensor_unit = "";
  let sensor_value = "";
  if (r.sensor_value !== "") {
    if (r.sensor_type === "ADC") {
      sensor_value = r.sensor_value;
      sensor_unit = "ADC";
    } else {
      sensor_value = Number(r.sensor_value).toFixed(5);
      sensor_unit = sensorUnits[r.sensor_type];
    }
  }

  const is_time_corrected = r.time_correction_sec !== "";
  const time_correction_sec = is_time_corrected ? Number(r.time_correction_sec) : null;

  return {
    time_correction_sec: time_correction_sec,
    is_time_corrected,
    time_utc: r.time_utc,
    device_time_utc: r.device_time_utc,
    full_id: r.full_id,
    serial: r.serial,
    sensor_value,
    sensor_unit,
    animals,
    animal_conflict,
    animal_name: animals.length === 1 ? animals[0].name || "" : "",
    animal_species: animals.length === 1 ? animals[0].speciesCommonName || "" : "",
    file_names,
  };
}

export function agGridSortToOrderBy(sortModel: SortModelItem[]): OrderBy[] {
  return sortModel.map(s => ({
    column: s.colId as OrderColumn,
    direction: s.sort === "asc" ? OrderDirection.ASC : OrderDirection.DESC,
  }));
}

export async function allDetQuery(
  start: number,
  limit: number,
  filters: DetectionFilterInput,
  orderBy: OrderBy[],
  includeAnimals: boolean,
  correctedTime: boolean
) {
  const params = { start, pageSize: limit, filters, orderBy, includeAnimals, correctedTime };
  return callGqlApi(
    gql`
      query allDet(
        $start: Int!
        $pageSize: Int!
        $filters: DetectionFilterInput
        $orderBy: [OrderBy!]
        $includeAnimals: Boolean!
        $correctedTime: Boolean
      ) {
        allDetections(
          start: $start
          pageSize: $pageSize
          filters: $filters
          orderBy: $orderBy
          includeAnimals: $includeAnimals
          correctedTime: $correctedTime
        ) {
          data
        }
      }
    `,
    params
  );
}
